module.exports = __webpack_public_path__ + "assets/a33ae280e60bcb60b653e3476e89802e.png";